import { getFirstEnterTime } from "@/api/data";
import infoList from "@/mixins/infoList";
import DataOptions from "../../components/timeList/dataOptions.vue";
export default {
  name: "temp",
  components: {
    DataOptions: DataOptions
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getFirstEnterTime,
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")]
    };
  },
  methods: {
    onSearchBtn: function onSearchBtn() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      this.getTableData();
    }
  },
  mounted: function mounted() {
    this.pageSize = 1000;
  }
};